import React, { useEffect } from "react";
import styled from "styled-components"
import {isMobile} from 'react-device-detect';

import Layout from "../components/layout"
import Container from "../components/container"
import PageHeader from "../components/header-page"

import maskIcon from "../images/mask.png"

import ReactGA from "react-ga4";
ReactGA.initialize("G-THHYTX4Y9V");

const Covid = styled.div`
  padding-bottom: 75px;

  ul {
    padding-left: 20px;

    li {
      margin-bottom: 20px;
    }
  }
`

function CovidPage(props) {
  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: "/covid", title: "Covid Policy"});
  }, []);

  return (
    <Layout page="covid" title="Covid Policy">
      <Container>
        <PageHeader style={{display: "flex", alignItems: "center"}}>
          <img src={maskIcon} width="100" alt="Mask" border="0" style={{marginRight: "10px"}} />
          COVID Policy for all Marshall Artists Series Events
        </PageHeader>
      </Container>

        <Covid>
          <Container>
            <ul>
              <li>
                All protocols &amp; safety measures are subject to change in response to the developing 
                state and public health standards and best practices
              </li>
              {/* <li>
                All guests, staff and volunteers are required to wear a face mask that completely covers 
                the nose and mouth at all times while in the venue.
              </li> */}
              <li>
                If any event is canceled you will receive a refund. If an event is postponed, all tickets 
                purchased will be honored on the new date. No other refunds will be available.
              </li>
              <li>
                Hand sanitizing areas will be available. 
              </li>
              {/* <li>
                <strong>DO NOT ATTTEND EVENTS</strong> if you currently or in the last 14 days have been sick, experienced a 
                fever or other symptoms or have been in direct contact with anyone who has shown symptoms in 
                the last 14 days.            
              </li> */}
            </ul>
          </Container>
      </Covid>     
    </Layout>
  );
}

export default CovidPage;